import React from 'react';
import { useTranslation } from 'react-i18next';
import defaultStyles from './Default.scss';
export var DetailItem = function (_a) {
    var name = _a.name, value = _a.value, _b = _a.transPrefix, transPrefix = _b === void 0 ? '' : _b;
    var t = useTranslation().t;
    if (!value) {
        return null;
    }
    // there are a metric ton of exif keys, so for sake of
    // sanity anything untranslated should just show the raw key name
    var translatedKey = t("deviation.details.".concat(transPrefix).concat(name.replace(' ', '')), {
        defaultValue: name,
    });
    return (React.createElement("div", { className: defaultStyles['detail-item'] },
        React.createElement("div", { className: defaultStyles['detail-key'] }, translatedKey),
        React.createElement("div", { className: defaultStyles['detail-value'] }, value)));
};
DetailItem.displayName = 'DetailItem';
export default DetailItem;
//# sourceMappingURL=DetailItem.js.map